import { Space, Typography, Button, Input, Form, Select, Flex } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { ActionType } from "./case.details";
import CustomReactQuillEditor from "../../../../components/editor/custom.quill.editor";

const { Text, Paragraph } = Typography;

export const getThemesFromCases = ({ cases = [] }) => {
  return cases
    ? cases
        ?.map(({ theme }) => ({
          uid: theme?.uid,
          name: theme?.name,
        }))
        .filter(
          (obj, index, self) =>
            index === self.findIndex((o) => o.uid === obj.uid)
        )
    : [];
};


const Scenario = ({
  currentElement,
  handleCancel,
  handleSave,
  isPreviewOn,
  form,
  formType,
  themes
}) => {

  return isPreviewOn || formType === ActionType.CREATE_NEW_CASE ? (
    <>
      <p>Title</p>
      <Form.Item
        name="title"
        style={{ width: "100%" }}
        rules={[{ required: true, message: "Title is required" }]}
      >
        <Input placeholder="Case title..." />
      </Form.Item>

      <p>Theme</p>
      <Form.Item
        name="theme"
        style={{ width: "100%" }}
        rules={[{ required: true, message: "Theme is required" }]}
      >
        <Select placeholder="Select theme..." style={{ fontSize: 16 }}>
          <Select.Option value={null}>--SELECT THEME--</Select.Option>
          {themes?.map((subject) => {
            return (
              <Select.Option value={subject?.uid}>
                {subject?.name}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>

      <p>Status</p>
      <Form.Item
        name="status"
        style={{ width: "100%" }}
        rules={[{ required: true, message: "Status is required" }]}
      >
        <Select placeholder="Select status..." style={{ fontSize: 16 }}>
          {["DRAFT", "PUBLISHED", "ARCHIVED"].map((status) => (
            <Select.Option key={status} value={status}>
              {status}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <p>Scenario</p>
      <Form.Item
        name="scenario"
        style={{ width: "100%" }}
        rules={[{ required: true, message: "Description is required" }]}
      >
        <CustomReactQuillEditor showCharCount={true} />
      </Form.Item>
      <Form.Item
        name="keyLearningPoints"
        label="Key Learning Points"
        style={{ width: "100%" }}
      >
        <CustomReactQuillEditor showCharCount={true} />
      </Form.Item>
      <Space>
        <Button type="dashed" icon={<SaveOutlined />} onClick={handleSave}>
          {currentElement ? "Save changes" : "Create new"}
        </Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </Space>
    </>
  ) : (
    <>
      <Paragraph type="secondary" style={{ fontSize: 20 }}>
        {form?.getFieldValue("title")}
      </Paragraph>
      <Paragraph>
        <Space>
          <Text type="secondary" style={{ fontSize: 18 }}>
            Status
          </Text>
          <Text style={{ fontSize: 18 }}>
            {form?.getFieldValue("status") ?? ""}
          </Text>
        </Space>
      </Paragraph>
      <Paragraph>
        <Space>
          <Text type="secondary" style={{ fontSize: 18 }}>
            Scenario
          </Text>
          <Paragraph style={{ fontSize: 18, lineHeight: 1.5 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: form?.getFieldValue("scenario") ?? "",
              }}
            ></div>
          </Paragraph>
        </Space>
      </Paragraph>
      <Paragraph>
        <Text type="secondary" style={{ fontSize: 18 }}>
          Key Learning Points
        </Text>
        <Paragraph style={{ fontSize: 18, lineHeight: 1.5 }}>
          <div
            dangerouslySetInnerHTML={{
              __html: form?.getFieldValue("keyLearningPoints")
            }}
          ></div>
        </Paragraph>
      </Paragraph>
    </>
  );
};

export default Scenario;
